import { injectReducer } from '../../store/reducers';

export default store => ({
    path: 'support',
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Support = require('./containers/SupportContainer').default;
      const reducer = require('./modules/support').default;

      injectReducer(store, { key: 'support', reducer });
      /*  Return getComponent   */
      cb(null, Support);
    },
    
    childRoutes: [
      {
        path: 'ticket/:id',
        getComponent(nextState, cb) {
          const Ticket = require('./containers/TicketContainer').default; // eslint-disable-line global-require
          const reducer = require('./modules/support').default; // eslint-disable-line global-require
          injectReducer(store, { key: 'support', reducer });
          cb(null, Ticket);
        }
      }
    ],
  });

export const CreateTicket = store => ({
  path: 'createticket',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    const CreateTicketsComponent = require('./containers/CreateTicketContainer').default; // eslint-disable-line global-require
    const reducer = require('./modules/support').default; // eslint-disable-line global-require
    injectReducer(store, { key: 'support', reducer });
    /*  Return getComponent   */
    cb(null, CreateTicketsComponent);
  },
});



// WEBPACK FOOTER //
// src/routes/support/index.js